import {
  CanvasElementType,
  CanvasObjectPosition,
  CanvasObjectSize,
  CanvasObjectStyles,
  CanvasStickyNoteSettings,
  FontWeight,
  TextAlignment,
} from '@y42/json-schema';
import type { VisualizationCanvasElementStoreModel } from '../visualization-canvas-element.model';
import { defaultCanvasGenericStyles } from './default-canvas-model-properties';

export const canvasStickyNoteStylesDefaultConstant: CanvasObjectStyles = {
  ...defaultCanvasGenericStyles,
  'border-color': '#5a9deb',
};

const canvasStickyNoteDefaultSettings: CanvasStickyNoteSettings = {
  textStyles: {
    'font-weight': FontWeight.Normal,
    'font-size': '16px',
    'font-family': 'Arial',
    'text-align': TextAlignment.Left,
    color: '#000',
  },
  text: '',
};

const canvasStickyNoteDefaultSize: CanvasObjectSize = {
  width: 300,
  height: 300,
};

export function getCanvasStickyNoteModel(data: { position: CanvasObjectPosition; backgroundColor: string }) {
  return {
    type: CanvasElementType.StickyNote,
    position: data.position,
    size: canvasStickyNoteDefaultSize,
    typeSettings: canvasStickyNoteDefaultSettings,
    styles: {
      ...canvasStickyNoteStylesDefaultConstant,
      'background-color': data.backgroundColor,
    },
  };
}

export type CanvasStickyNoteModel = VisualizationCanvasElementStoreModel<CanvasElementType.StickyNote>;
